import { ArrowDown, ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const FLOW = [
    "You Wave 🌿",
    "They don’t know it’s you",
    "They Wave too 🌿",
    "You connect",
];

export const PrivateWaves = () => (
    <section className="bg-[#F0EFEB]" data-testid="private-waves-section">
        <div className="mx-auto max-w-6xl px-6 py-24 sm:py-28">
            <Reveal className="max-w-2xl">
                <div data-testid="private-waves-chapter">
                    <Chapter index="02" label="Private Waves" />
                </div>
                <h2
                    data-testid="private-waves-heading"
                    className="font-display mt-5 text-4xl font-medium leading-[1.1] tracking-tight text-[#1D201A] sm:text-5xl"
                >
                    Wave without the{" "}
                    <span className="whitespace-nowrap">awkward bit. 🌿</span>
                </h2>
            </Reveal>

            <Reveal delay={0.12}>
                <div
                    data-testid="private-waves-flow"
                    className="mt-12 flex flex-col items-stretch gap-3 lg:flex-row lg:items-center"
                >
                    {FLOW.map((step, i) => (
                        <div key={step} className="flex flex-col items-center gap-3 lg:flex-row">
                            <div
                                data-testid={`private-wave-step-${i + 1}`}
                                className={`flex min-h-[72px] w-full items-center justify-center rounded-3xl border px-5 py-4 text-center text-sm font-medium leading-snug lg:min-w-[190px] ${
                                    i === 3
                                        ? "border-[#2C3618] bg-[#2C3618] text-[#F9F8F4]"
                                        : "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]"
                                }`}
                            >
                                {step}
                            </div>
                            {i < FLOW.length - 1 && (
                                <>
                                    <ArrowRight
                                        className="hidden h-4 w-4 shrink-0 text-[#899B6A] lg:block"
                                        strokeWidth={1.75}
                                        aria-hidden="true"
                                    />
                                    <ArrowDown
                                        className="h-4 w-4 shrink-0 text-[#899B6A] lg:hidden"
                                        strokeWidth={1.75}
                                        aria-hidden="true"
                                    />
                                </>
                            )}
                        </div>
                    ))}
                </div>
                <p
                    data-testid="private-waves-no-rejection"
                    className="mt-8 text-sm font-medium text-[#5C5F58] sm:text-base"
                >
                    No visible rejection. A Wave is only shared when it’s mutual.
                </p>
            </Reveal>
        </div>
    </section>
);
